<app-header  ></app-header>



  <div>
    <app-menu></app-menu>
  </div>



  <div  style="padding-left: 100px;padding-top: 80px;">
   
<!-- <ngx-guided-tour style="position: fixed;
left: 97.5%;
top: 95%;"></ngx-guided-tour> -->
    <router-outlet></router-outlet>


  </div>



  <!-- <div>
    <div>
      <h1>
        <span class="demo-title"></span>
      </h1>
    </div>
  
  
    <div>
      <button (click)="restartTour()">
        Restart Tour
      </button>
    </div>
  
  
  


  </div> -->